import { arrayConverter, renderChildren } from "./helpers";
export default (function (_a) {
    var filterList = _a.filterList;
    var componentsToRender = filterList
        .filter(function (item) { return item && item.selector; })
        .map(function (item) { return item && item.component; });
    var reduced = arrayConverter(componentsToRender, 1);
    return reduced.length > 0 ? renderChildren(reduced, 1, true) : null;
});
//# sourceMappingURL=SelectorChild.js.map